import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { DropzoneOptions } from 'react-dropzone';
import { addUploadingFile, setFilePendingConfirmation } from '../state/actions';
import { useRouteParams } from './useRouteParams';
import { useListEntitiesQuery } from '../api/useListEntitiesQuery';

interface FileWithPath {
  fileId: string;
  file: File;
  path: string;
}

export const useDropzoneOptions = (): DropzoneOptions => {
  const { clientId, path, providerType, filterableByYear } = useRouteParams();

  const dispatch = useDispatch();

  const { data } = useListEntitiesQuery({ clientId, path, providerType, filterableByYear });

  const hasDuplicateFileName = (file: File) => {
    return (
      data &&
      data.items.find(({ name }) => name.trim().toLowerCase() === file.name.trim().toLowerCase())
    );
  };

  return {
    onDropAccepted(files) {
      const { duplicateFiles, originalFiles } = files.reduce(
        (acc, file: File) => {
          if (hasDuplicateFileName(file)) {
            return {
              ...acc,
              duplicateFiles: [...acc.duplicateFiles, { fileId: uuidv4(), file, path }],
            };
          }

          return {
            ...acc,
            originalFiles: [...acc.originalFiles, { fileId: uuidv4(), file, path }],
          };
        },
        {
          duplicateFiles: [] as FileWithPath[],
          originalFiles: [] as FileWithPath[],
        },
      );

      if (duplicateFiles.length > 0) {
        return dispatch(setFilePendingConfirmation(duplicateFiles));
      }

      return originalFiles.forEach(originalFile => {
        dispatch(addUploadingFile(originalFile));
      });
    },
  };
};
